class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('.modal__close-button, button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.positionSearch = () => {
      const header = this.closest('.section-header');
      const viewport = window.visualViewport;
      const mobile = matchMedia('(max-width:749px)').matches;
      const top = mobile ? (viewport?.offsetTop || 0) : Math.max(0, Math.min(header?.getBoundingClientRect().bottom || 0, 120));
      this.style.setProperty('--njt-search-top', top + 'px');
      this.style.setProperty('--njt-search-height', ((viewport?.height || innerHeight) - (mobile ? 0 : top)) + 'px');
    };
    this.positionSearch();
    window.addEventListener('resize', this.positionSearch);
    window.visualViewport?.addEventListener('resize', this.positionSearch);
    window.visualViewport?.addEventListener('scroll', this.positionSearch);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    window.removeEventListener('resize', this.positionSearch);
    window.visualViewport?.removeEventListener('resize', this.positionSearch);
    window.visualViewport?.removeEventListener('scroll', this.positionSearch);
    this.querySelectorAll('njt-smart-search').forEach(search => { search.cancel?.(); search.hide?.(); });
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
